//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Result from "./components/Result.vue";
export default {
	name: "OCCSearch",
	components: {
		Result,
	},
	data() {
		return {
			typeName: false
		}
	},
	methods: {
		extendType({extend, done}) {
			extend(extended => {
				// if the typeName value exists (below in created) extende the type
				// if not, do not extend type
				// -- typeName used for both fieldName and displayName because only displayName is used by BE,  
				// fieldName is ignored by BE, so typeName passed in there as dummy text 
				if (this.typeName) {
					extended.type = {
						fieldName: this.typeName,
						displayName: this.typeName
					};
				}
				return extended;
			});
			done();
		},
	},
	created() {
		// if the data-type-filter attr exists and has a non-empty value, then
		// set the typeName data variable to its value, to be used in extendType above
		if (!!this.$root.options.typeFilter) {
			this.typeName = this.$root.options.typeFilter;
			console.log(this.typeName);
		}
	}
};
